<!--
 * @Description:优惠码详情
 * @Author: JDY
 * @Date: 2021-04-25 14:20:09
 * @LastEditTime: 2021-04-25 15:36:36
 * @LastEditors: JDY
-->
<template>
  <a-card :bordered="false" :loading="loading">
    <a-descriptions bordered>
      <a-descriptions-item label="标题" :span="3">
        {{ info.title }}
      </a-descriptions-item>
      <a-descriptions-item label="优惠码" :span="2">
        {{ info.code }}
      </a-descriptions-item>
      <a-descriptions-item label="折扣" :span="1"> {{ info.discount }}% </a-descriptions-item>
      <a-descriptions-item label="状态" :span="1">
        <a-badge v-if="info.state === 1" status="default" text="未使用" />
        <a-badge v-if="info.state === 2" status="error" text="废弃" />
        <a-badge v-if="info.state === 3" status="warning" text="已分发" />
        <a-badge v-if="info.state === 4" status="success" text="已使用" />
      </a-descriptions-item>
      <a-descriptions-item label="使用次数" :span="1">
        {{ info.limit_count }}
      </a-descriptions-item>
      <a-descriptions-item label="已用次数" :span="1">
        {{ info.use_count }}
      </a-descriptions-item>
      <a-descriptions-item label="可用时间" :span="3">
        {{ info.start_at }} {{ info.start_at && info.end_at ? '至' : '' }} {{ info.end_at }}
      </a-descriptions-item>
      <!-- <a-descriptions-item label="可用课程" :span="3">
        {{ info.use_course }}
      </a-descriptions-item>
      <a-descriptions-item label="可用证书" :span="3">
        {{ info.use_certificate }}
      </a-descriptions-item>
      <a-descriptions-item label="可用套购" :span="3">
        {{ info.ues_arbitrage }}
      </a-descriptions-item>
      <a-descriptions-item label="可用企业" :span="3">
        {{ info.use_company }}
      </a-descriptions-item>
      <a-descriptions-item label="可用用户" :span="3">
        <p>用户：{{ info.use_user }}</p>
        <p>邮箱：{{ info.use_email }}</p>
        <p>手机号：{{ info.use_phone }}</p>
      </a-descriptions-item> -->
      <a-descriptions-item label="处理人" :span="3">
        {{ info.handle_user }}
      </a-descriptions-item>
      <a-descriptions-item label="备注" :span="3">
        {{ info.remark }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script>
export default {
    name: 'CouponDetail',
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            loading: true
        }
    },
    mounted () {
        const that = this
        setTimeout(() => {
            that.loading = false
        }, 500)
    },
    methods: {
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            return new Promise(resolve => {
                resolve(true)
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.avatar {
    margin-bottom: 15px;
    text-align: center;
}

.account-center-detail {
    margin-top: 1rem;
}
.title {
    font-weight: bold;
    font-size: 1rem;
    color: #4a4a4a;
}
</style>
